import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {ContrCalcParam} from '../../../../../../../projects/api/src/contr-calc-param/contr-calc-param.model';
import {ContrDeviceParam} from '../../../../../../../projects/api/src/contr-device-param/contrdeviceparam.model';
import {PARAM_TYPE} from '@inspark/widget-common';
import {showTooltip} from '../../../../shared/page-standard-forms/standard-form-builder/standard-form.helpers';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-form-param-value',
  templateUrl: './form-param-value.component.html',
  styleUrls: ['./form-param-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormParamValueComponent implements OnInit, OnChanges {

  PARAM_TYPE = PARAM_TYPE;
  @Input() param: ContrCalcParam | ContrDeviceParam;
  @Input() isEditable = false;
  @Input() waiting = false;
  @Input() hideIcons = false;
  @Input() showChartIcon = false;
  @Input() maxCharsLength = 0;
  @Input() showOverlayIcon? = false;
  @Output() toChart: EventEmitter<any> = new EventEmitter();
  @Output() updateValue: EventEmitter<any> = new EventEmitter();
  isEditMode = false;
  value = '';
  isDeviceStateRefusal = false;
  showImageError = false;
  throttleTs = 0;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    this.value = this.param.curvalue + '';
    this.showImageError = false;
    console.log('this.param: ', this.param);
  }

  ngOnChanges(changes) {
    if (changes.param && changes.param.currentValue) {
      this.value = this.param.curvalue + '';
      this.isEditMode = false;
      this.checkValue();
    }
  }

  checkValue() {
    if (this.param) {

      if ('devicestate' in this.param) {
        this.isDeviceStateRefusal = this.param.devicestate && this.param.devicestate?.id === 0;
      }
      // if (this.param.deviceparam && this.param.deviceparam.channel.valuetype.id === PARAM_TYPE.signal) {
      //   const measureunit = this.param.deviceparam.channel.paramcategory.measureunit.split('/');
      //   if (this.param && this.param.iconset) {
      //     const off = this.param.iconset.filter(_param => _param.stateId === 3);
      //     if (off && off.length === 1) {
      //       this.labelOff = off[0].label ? off[0].label : 'Off';
      //     } else {
      //       this.labelOff = measureunit[1];
      //     }
      //     const on = this.param.iconset.filter(_param => _param.stateId === 1);
      //     if (on && on.length === 1) {
      //       this.labelOn = on[0].label ? on[0].label : 'On';
      //     } else {
      //       this.labelOn = measureunit[0];
      //     }
      //
      //     if (this.param.predefinedParam) {
      //       this.value = this.param.curValueP;
      //     } else {
      //       this.value = parseInt(this.param.curvalue, 10) === SIGNAL_ON ? this.labelOn : this.labelOff;
      //     }
      //   } else {
      //     if (this.param.predefinedParam) {
      //       this.value = this.param.curValueP;
      //     } else {
      //       this.value = parseInt(this.param.curvalue, 10) === SIGNAL_ON ? measureunit[0] : measureunit[1];
      //     }
      //   }
      // } else if (this.param.predefinedParam) {
      //   this.value = this.param.curValueP;
      // } else {
      //   this.value = this.param.curvalue;
      // }
    }
  }

  changeEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  showTooltip($event: MouseEvent) {
    showTooltip($event);
  }

  copy2clipboard($event) {
    if (navigator.clipboard) { // Chrome
      navigator.clipboard.writeText(this.param.curvalue + '').then(function() {
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    } else { // Internet Explorer
      const textArea = document.createElement('textarea');
      textArea.value = this.param.curvalue + '';

      // Avoid scrolling to bottom
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }
    $event.target.title = this.translateService.instant('Current value copied') + '!';
  }

  getTypeName(id) {
    if (id === 5) {
      return 'VALUE_TYPES.FULL.STRING';
    } else if (id === 6) {
      return 'VALUE_TYPES.FULL.IMAGE';
    } else if (id === 7) {
      return 'VALUE_TYPES.FULL.TEXT';
    } else if (id === 8) {
      return 'VALUE_TYPES.FULL.GEO';
    } else if (id === 9) {
      return 'VALUE_TYPES.FULL.VIDEO';
    }
  }
  getImageUrl(s) {
    let ts = new Date().getTime();
    if ((ts - this.throttleTs) < 1000) {
      return;
    }
    this.showImageError = false;
    //let extension = (s + '').split('.').pop().toLowerCase();
    //const isSuccess = ['jpg', 'jpeg', 'png', 'gif','tiff', 'bmp', 'ai', 'svg', 'eps', 'pds', 'pdf'].indexOf(extension) > -1;
    const isSuccess = this.isValidHttpUrl((s + ''));
    if (isSuccess) {
      //return `/webdav/${s}`;
      return `${s}`;
    }
    return `${environment.backEndUrlPrefix}/files/${s}`;
  }

  isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  handleImageError($event) {
    this.throttleTs = new Date().getTime();
    const imgElement = event.target as HTMLImageElement;
    imgElement.style.display = 'none';
    this.showImageError = true;
  }
}
